import { Link } from "react-router-dom";
import { SignpostSplit } from "react-bootstrap-icons";
import { Layout } from "../layouts";

export const Error404 = () => {
  return (
    <Layout>
      <div className="error-404">
        <div className="error-404-icon">
          <SignpostSplit size={36} />
        </div>
        <div className="error-404-code">404</div>
        <h1 className="error-404-title">Page Not Found</h1>
        <p className="error-404-message">
          The page you're looking for doesn't exist or may have been moved.
          Let's get you back on track.
        </p>
        <div className="error-404-actions">
          <Link className="btn btn-primary" to="/menu">
            Explore Our Menu
          </Link>
          <Link className="error-404-home-link" to="/">
            Back to Home
          </Link>
        </div>
      </div>
    </Layout>
  );
};
